var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"af7fd983787511640466cd859466c81980abfc2d"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import { RewriteFrames } from "@sentry/integrations"
import * as Sentry from "@sentry/nextjs"

const NODE_ENV = process.env.NODE_ENV
const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN
const SENTRY_ENVIRONMENT = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT

const ignoreErrorsList = [
  "Failed to execute 'removeChild' on 'Node'",
  "Failed to execute 'insertBefore' on 'Node'", 
  "chrome-extension", 
  "removeChild",
  "gqlRequest(src/common/helpers/fetcher)",
  "this.retryer.onSuccess",  
  "this.retryer.onSuccess(src/query)",
  "Minified Lexical",  
  "websocket error",  
  "fetch(src/instrument)",  
  "fetchCallImpl",  
  "Cannot read properties of null (reading 'getItem')",  
  "reading 'removeEventListener'",  
  "browser-perf",  
  "p.makeError",  
  "NetworkError when attempting to fetch resource", 
  "window.ReactNativeWebView.postMessage",  
  "chunks/pages/_app", 
  "chunks/src/",
  "Load Failed",
  "GET /mockServiceWorker.js",
  "Cannot write private member",
  "e.listConnectors is not a function",
  "Error: Socket stalled when trying to connect to wss://relay.walletconnect.org",
  "Error: WebSocket connection failed for host: wss://relay.walletconnect.org",
  "WebSocket connection failed for host: wss://relay.walletconnect.com",
  "Socket stalled when trying to connect to wss://relay.walletconnect.com",
  "Error: Extension context invalidated.",
  "TypeError",
  "NS_ERROR_CONTENT_BLOCKED",
  "<unknown>",
  "Object captured as promise rejection with keys: code, message",
  "Object captured as promise rejection with keys: code, message, stack",
  "Object captured as promise rejection with keys: code, data, message",
  "Object captured as promise rejection with keys: code, data",
  "TypeError: Cannot destructure property 'register' of 'undefined' as it is undefined.",
  "SecurityError",
  "UserRejectedRequestError: User rejected request",
  "To use QR modal, please install @walletconnect/modal package",
  "ResourceUnavailable",
  "Invalid regular expression: invalid group specifier name",
  "Error: Extension context invalidated.",
  "Extension context invalidated.",
  "Navigation cancelled due to unsaved changes",
  "Talisman extension has not been configured yet. Please continue with onboarding.",
  "Attempting to use a disconnected port object",
  "No matching key",
  "The request by this Web3 provider is timeout.",
  "Could not establish connection. Receiving end does not exist.",
  "The object can not be found here."
]


Sentry.init({
  enabled: NODE_ENV === "production",
  dsn: SENTRY_DSN,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 0.1,

  integrations: [
    new Sentry.BrowserTracing(),
    new RewriteFrames({ 
      iteratee: (frame) => {
        frame.filename.replace("%5B", "[").replace("%5D", "]")

        return frame
      }
    }),
    new Sentry.Replay()
  ],
  tracesSampleRate: 0.1,
  environment: SENTRY_ENVIRONMENT,
  maxValueLength: 2000,
  ignoreErrors: ignoreErrorsList
})
